import { MenuComponent } from '@/_metronic/assets/ts/components'
import { DropdownSelect } from '@/_metronic/partials/content/dropdown-select/DropdownSelect'
import PropagateWrapper from '@/_metronic/partials/content/propagate/PropagateWrapper'
import { useEffect, useRef, useState } from 'react'
import { useFilterReportSalesBudget } from '../../core/FilterReportSalesBudgetProvider'
import { initialFilter } from '../../core/_models'
import { FilterDropdownBrand } from './FilterDropdownBrand'
import { FilterDropdownCity } from './FilterDropdownCity'
import { FilterDropdownOutlet } from './FilterDropdownOutlet'
import { FilterDropdownRegion } from './FilterDropdownRegion'
import { useQueryRequestDaily } from '../../core/QueryRequestDailyProvider'
import { SingleDatePicker } from '@/_metronic/partials/content/single-datepicker/SingleDatePicker'
import moment from 'moment'
import { Console } from 'console'

const optionsArea = [
  { value: 'WIB', label: 'WIB' },
  { value: 'WITA', label: 'WITA' },
  { value: 'WIT', label: 'WIT' },
]

const optionsMonth = [
  { value: '1', label: 'January' },
  { value: '2', label: 'February' },
  { value: '3', label: 'March' },
  { value: '4', label: 'April' },
  { value: '5', label: 'May' },
  { value: '6', label: 'June' },
  { value: '7', label: 'July' },
  { value: '8', label: 'August' },
  { value: '9', label: 'September' },
  { value: '10', label: 'October' },
  { value: '11', label: 'November' },
  { value: '12', label: 'December' },
]

const FilterReportSalesBudgetDailyForm = ({ closeModal }) => {
  const { updateFilterReportSalesBudgetFormDailyValue, filterReportSalesBudgetFormDailyValue } =
    useFilterReportSalesBudget()
  const { updateState } = useQueryRequestDaily()
  const [filterValue, setFilterValue] = useState(initialFilter)
  const [selectedArea, setSelectedArea] = useState<any>([])
  const [selectedMonth, setSelectedMonth] = useState<any>([])
  const [selectedOutlet, setSelectedOutlet] = useState<any>([])
  const [selectedRegion, setSelectedRegion] = useState<any>([])
  const [selectedCity, setSelectedCity] = useState<any>([])
  const [selectedBrand, setSelectedBrand] = useState<any>([])
  const [selectedSubBrand, setSelectedSubBrand] = useState<any>([])
  const [optionsYear, setOptionsYear] = useState<any>(null)
  const [selectedYear, setSelectedYear] = useState<any>(null)
  const currentDate = new Date()
  const requestDateRef = useRef<any>()
  const requestEndDateRef = useRef<any>()
  const [key, setKey] = useState(Date.now())

  useEffect(() => {
    MenuComponent.reinitialization()
  }, [])

  useEffect(() => {
    const currentYear = new Date().getFullYear()
    const years = Array.from({ length: 5 }, (_, index) => currentYear - 4 + index)
    setOptionsYear(years?.map((x) => ({ label: x, value: x })))
    setSelectedYear({ value: currentDate.getFullYear(), label: currentDate.getFullYear() })
    setFilterValue({
      ...filterValue,
      start_date: moment().startOf("month").local().format('yyyy-MM-DD'),
      end_date: moment().endOf('month').local().format('yyyy-MM-DD'),
    })


    if (filterReportSalesBudgetFormDailyValue) {
      setSelectedArea(filterReportSalesBudgetFormDailyValue.area)
      setSelectedMonth(filterReportSalesBudgetFormDailyValue.month)
      setSelectedOutlet(filterReportSalesBudgetFormDailyValue.outlet)
      setSelectedBrand(filterReportSalesBudgetFormDailyValue.brand)
      setSelectedSubBrand(filterReportSalesBudgetFormDailyValue.sub_brand)
      setSelectedYear(filterReportSalesBudgetFormDailyValue.year)
      setSelectedRegion(filterReportSalesBudgetFormDailyValue.region)
      setSelectedCity(filterReportSalesBudgetFormDailyValue.city)

      let monthList: string[] = []
      if (filterReportSalesBudgetFormDailyValue.month) {
        filterReportSalesBudgetFormDailyValue.month.forEach((element) => {
          monthList.push(element.value)
        })
      }
      let areaList: string[] = []
      if (filterReportSalesBudgetFormDailyValue.area) {
        filterReportSalesBudgetFormDailyValue.area.forEach((element) => {
          areaList.push(element.value)
        })
      }
      let outletList: string[] = []
      if (filterReportSalesBudgetFormDailyValue.outlet) {
        filterReportSalesBudgetFormDailyValue.outlet.forEach((element) => {
          outletList.push(element.value)
        })
      }
      let brandList: string[] = []
      if (filterReportSalesBudgetFormDailyValue.brand) {
        filterReportSalesBudgetFormDailyValue.brand.forEach((element) => {
          brandList.push(element.value)
        })
      }
      let subBrandList: string[] = []
      if (filterReportSalesBudgetFormDailyValue.sub_brand) {
        filterReportSalesBudgetFormDailyValue.sub_brand.forEach((element) => {
          subBrandList.push(element.value)
        })
      }
      let regionList: string[] = []
      if (filterReportSalesBudgetFormDailyValue.region) {
        filterReportSalesBudgetFormDailyValue.region.forEach((element) => {
          regionList.push(element.value)
        })
      }
      let cityList: string[] = []
      if (filterReportSalesBudgetFormDailyValue.city) {
        filterReportSalesBudgetFormDailyValue.city.forEach((element) => {
          cityList.push(element.value)
        })
      }

      setFilterValue({
        ...filterValue,
        set_area: Boolean(filterReportSalesBudgetFormDailyValue.area),
        area: areaList,
        set_outlet_id: Boolean(filterReportSalesBudgetFormDailyValue.outlet),
        outlet_id: outletList,
        set_brand_id: Boolean(filterReportSalesBudgetFormDailyValue.brand),
        brand_id: brandList,
        set_sub_brand_id: Boolean(filterReportSalesBudgetFormDailyValue.sub_brand),
        sub_brand_id: subBrandList,
        set_region_id: Boolean(filterReportSalesBudgetFormDailyValue.region),
        region_id: regionList,
        set_city_id: Boolean(filterReportSalesBudgetFormDailyValue.city),
        city_id: cityList,
        set_month: Boolean(filterReportSalesBudgetFormDailyValue.month),
        month: monthList,
        set_year: Boolean(filterReportSalesBudgetFormDailyValue.year),
        year: filterReportSalesBudgetFormDailyValue.year
          ? filterReportSalesBudgetFormDailyValue.year.value.toString()
          : currentDate.getFullYear().toString(),
      })
      setKey(Date.now())
    } else {
      updateFilterReportSalesBudgetFormDailyValue({
        ...filterReportSalesBudgetFormDailyValue,
        start_date: moment().local().format('yyyy-MM-DD'),
        end_date: moment().endOf('month').local().format('yyyy-MM-DD'),
      })
      setKey(Date.now())
    }
  }, [])

  const resetData = () => {
    setSelectedOutlet([])
    setSelectedYear({ value: currentDate.getFullYear(), label: currentDate.getFullYear() })
    setSelectedArea([])
    setSelectedBrand([])
    setSelectedSubBrand([])
    setSelectedRegion([])
    setSelectedCity([])
    setSelectedMonth([])
    setFilterValue({
      ...filterValue,
      start_date: moment().startOf('month').local().format('yyyy-MM-DD'),
      end_date: moment().endOf('month').local().format('yyyy-MM-DD'),
    })
    updateFilterReportSalesBudgetFormDailyValue({
      start_date: moment().startOf('month').local().format('yyyy-MM-DD'),
      end_date: moment().endOf('month').local().format('yyyy-MM-DD'),
    })
    // updateFilterReportSalesBudgetFormDailyValue(null)
    // updateFilterReportSalesBudgetFormDailyValue({
    //   year: {value: currentDate.getFullYear(), label: currentDate.getFullYear()},
    // })
    updateState(initialFilter)
    closeModal()
  }

  const filterData = () => {
    filterValue.set_brand_id = filterValue.brand_id && filterValue.brand_id.length > 0
    filterValue.set_sub_brand_id = filterValue.sub_brand_id && filterValue.sub_brand_id.length > 0
    filterValue.set_region_id = filterValue.region_id && filterValue.region_id.length > 0
    filterValue.set_city_id = filterValue.city_id && filterValue.city_id.length > 0
    filterValue.set_area = filterValue.area && filterValue.area.length > 0
    filterValue.set_outlet_id = filterValue.outlet_id && filterValue.outlet_id.length > 0
    filterValue.set_date = true
    updateState(filterValue)
    closeModal()
  }

  const onChangeSelected = (name: string) => (value) => {
    if (name === 'area') {
      setSelectedArea(value)

      let areaList: string[] = []
      if (value) {
        value.forEach((element) => {
          areaList.push(element.value)
        })
      }
      setFilterValue({
        ...filterValue,
        set_area: Boolean(areaList),
        area: areaList,
      })
      updateFilterReportSalesBudgetFormDailyValue({
        ...filterReportSalesBudgetFormDailyValue,
        area: value,
      })
    } else if (name === 'month') {
      setSelectedMonth(value)

      let monthList: string[] = []
      if (value) {
        value.forEach((element) => {
          monthList.push(element.value)
        })
      }

      setFilterValue({
        ...filterValue,
        set_month: Boolean(monthList),
        month: monthList,
      })
      updateFilterReportSalesBudgetFormDailyValue({
        ...filterReportSalesBudgetFormDailyValue,
        month: value,
      })
    } else if (name === 'year') {
      if (value) {
        setSelectedYear(value)
      } else {
        setSelectedYear({ value: currentDate.getFullYear(), label: currentDate.getFullYear() })
      }
      setFilterValue({
        ...filterValue,
        set_year: true,
        year: value && value.value.toString(),
      })
      updateFilterReportSalesBudgetFormDailyValue({
        ...filterReportSalesBudgetFormDailyValue,
        year: value ? value : { value: currentDate.getFullYear(), label: currentDate.getFullYear() },
      })
    }
  }

  console.log(moment(filterValue?.start_date + 'T00:00:00.000Z').add(29, 'd'))

  return (
    <>
      <div className='px-7 py-5' data-kt-user-table-filter='form'>
        <PropagateWrapper>
          <div className='row'>
            <div className='col-6'>
              <div className='mb-10'>
                <label className='form-label fs-6 fw-bold'>Brand:</label>
                <FilterDropdownBrand
                  currentValue={selectedBrand || null}
                  onValueChange={(value) => {
                    setSelectedBrand(value)
                    let brandList: string[] = []
                    if (value) {
                      value.forEach((element) => {
                        brandList.push(element.value)
                      })
                    }
                    setFilterValue({
                      ...filterValue,
                      set_brand_id: Boolean(brandList),
                      brand_id: brandList,
                    })
                    updateFilterReportSalesBudgetFormDailyValue({
                      ...filterReportSalesBudgetFormDailyValue,
                      brand: selectedBrand,
                    })
                  }}
                />
              </div>
            </div>
            <div className='col-6'>
              <div className='mb-10'>
                <label className='form-label fs-6 fw-bold'>Sub Brand:</label>
                <FilterDropdownBrand
                  currentValue={selectedSubBrand || null}
                  onValueChange={(value) => {
                    setSelectedSubBrand(value)
                    let subBrandList: string[] = []
                    if (value) {
                      value.forEach((element) => {
                        subBrandList.push(element.value)
                      })
                    }
                    setFilterValue({
                      ...filterValue,
                      set_sub_brand_id: Boolean(subBrandList),
                      sub_brand_id: subBrandList,
                    })
                    updateFilterReportSalesBudgetFormDailyValue({
                      ...filterReportSalesBudgetFormDailyValue,
                      sub_brand: selectedSubBrand,
                    })
                  }}
                />
              </div>
            </div>
            <div className='col-6'>
              <div className='mb-10'>
                <label className='form-label fs-6 fw-bold'>Region:</label>
                <FilterDropdownRegion
                  currentValue={selectedRegion || null}
                  onValueChange={(value) => {
                    setSelectedRegion(value)
                    let regionList: string[] = []
                    if (value) {
                      value.forEach((element) => {
                        regionList.push(element.value)
                      })
                    }
                    setFilterValue({
                      ...filterValue,
                      set_region_id: Boolean(regionList),
                      region_id: regionList,
                    })
                    updateFilterReportSalesBudgetFormDailyValue({
                      ...filterReportSalesBudgetFormDailyValue,
                      region: selectedRegion,
                    })
                  }}
                />
              </div>
            </div>
            <div className='col-6'>
              <div className='mb-10'>
                <label className='form-label fs-6 fw-bold'>City:</label>
                <FilterDropdownCity
                  currentValue={selectedCity || null}
                  onValueChange={(value) => {
                    setSelectedCity(value)
                    let cityList: string[] = []
                    if (value) {
                      value.forEach((element) => {
                        cityList.push(element.value)
                      })
                    }
                    setFilterValue({
                      ...filterValue,
                      set_city_id: Boolean(cityList),
                      city_id: cityList,
                    })
                    updateFilterReportSalesBudgetFormDailyValue({
                      ...filterReportSalesBudgetFormDailyValue,
                      city: selectedCity,
                    })
                  }}
                />
              </div>
            </div>
            <div className='col-6'>
              <div className='mb-10'>
                <label className='form-label fs-6 fw-bold'>Area:</label>
                <DropdownSelect
                  options={optionsArea}
                  value={selectedArea}
                  onChange={onChangeSelected('area')}
                  placeholder='All Area'
                  isMulti
                  isClearable
                />
              </div>
            </div>
            <div className='col-6'>
              <div className='mb-10'>
                <label className='form-label fs-6 fw-bold'>Outlet:</label>
                <FilterDropdownOutlet
                  placeholder='All Outlet'
                  currentValue={selectedOutlet || null}
                  onValueChange={(value) => {
                    setSelectedOutlet(value)
                    let outletList: string[] = []
                    if (value) {
                      value.forEach((element) => {
                        outletList.push(element.value)
                      })
                    }
                    setFilterValue({
                      ...filterValue,
                      set_outlet_id: Boolean(outletList),
                      outlet_id: outletList,
                    })
                    updateFilterReportSalesBudgetFormDailyValue({
                      ...filterReportSalesBudgetFormDailyValue,
                      outlet: selectedOutlet,
                    })
                  }}
                  isDisabled={false}
                />
              </div>
            </div>
            <div className='col-6'>
              <div className='mb-10'>
                <label className='form-label fs-6 fw-bold'>Start Date:</label>
                <SingleDatePicker
                  pickerRef={requestDateRef}
                  startDate={
                    filterReportSalesBudgetFormDailyValue && filterReportSalesBudgetFormDailyValue.start_date
                      ? moment(filterReportSalesBudgetFormDailyValue.start_date).format('MM/DD/yyyy')
                      : moment().startOf('month').format('MM/DD/yyyy')
                  }
                  onCallback={(start_date) => {
                    const outputDateString = moment(start_date).format('yyyy-MM-DD')
                    const diffDay = moment(filterValue.end_date).diff(start_date, 'days') + 1

                    if (isNaN(diffDay) || diffDay < 1 || diffDay > 31) {

                      const outputEndDateString = moment(start_date).add(30, 'day')
                      const formattedEndDateString = outputEndDateString.format('yyyy-MM-DD')
                      const formattedEndDateRefString = outputEndDateString.format('MM/DD/yyyy')

                      if(requestEndDateRef.current){
                        requestEndDateRef.current.setStartDate(formattedEndDateRefString)
                        requestEndDateRef.current.setEndDate(formattedEndDateRefString)
                      }

                      setFilterValue({
                        ...filterValue,
                        start_date: outputDateString,
                        end_date: formattedEndDateString,
                      })
                      updateFilterReportSalesBudgetFormDailyValue({
                        ...filterReportSalesBudgetFormDailyValue,
                        start_date: outputDateString,
                        end_date: formattedEndDateString,
                      })

                    } else {

                      setFilterValue({
                        ...filterValue,
                        start_date: outputDateString,
                      })
                      updateFilterReportSalesBudgetFormDailyValue({
                        ...filterReportSalesBudgetFormDailyValue,
                        start_date: outputDateString,
                      })

                    }

                    setKey(Date.now())

                  }}
                  disabled={false}
                  placeholder='Select end date'
                />
              </div>
            </div>
            <div className='col-6'>
              <div className='mb-10'>
                <label className='form-label fs-6 fw-bold'>End Date:</label>
                {<SingleDatePicker
                  key={key}
                  pickerRef={requestEndDateRef}
                  minDate={moment(filterValue.start_date + 'T00:00:00.000Z')}
                  maxDate={moment(filterValue.start_date + 'T00:00:00.000Z').add(30, 'd')}
                  startDate={
                    filterReportSalesBudgetFormDailyValue && filterReportSalesBudgetFormDailyValue.end_date
                      ? moment(filterReportSalesBudgetFormDailyValue.end_date).format('MM/DD/yyyy')
                      : moment().endOf('month').format('MM/DD/yyyy')
                  }
                  onCallback={(end_date) => {
                    const outputDateString = moment(end_date).format('yyyy-MM-DD')
                    setFilterValue({
                      ...filterValue,
                      end_date: outputDateString,
                    })
                    updateFilterReportSalesBudgetFormDailyValue({
                      ...filterReportSalesBudgetFormDailyValue,
                      end_date: outputDateString,
                    })
                  }}
                  disabled={false}
                  placeholder='Select end date'
                />}
              </div>
            </div>
          </div>
        </PropagateWrapper>
        <div className='d-flex justify-content-end'>
          <button
            type='button'
            // disabled={isLoading}
            onClick={resetData}
            className='btn btn-light btn-active-light-primary fw-bold me-2 px-6'
            data-kt-menu-dismiss='true'
            data-kt-user-table-filter='reset'
          >
            Reset
          </button>
          <button
            // disabled={isLoading}
            type='button'
            onClick={filterData}
            className='btn btn-primary fw-bold px-6'
            data-kt-menu-dismiss='true'
            data-kt-user-table-filter='filter'
          >
            Apply
          </button>
        </div>
      </div>
    </>
  )
}

export { FilterReportSalesBudgetDailyForm }

